<template>
  <div>
    <div>
      <b-card-footer class="p-0 m-0">
        <!-- The Buttons with the Question number -->
        <div
          v-for="(questionsArray, index) in currentTabQuestions"
          :key="index"
          class="hobtn pl-lg-5"
        >
          <b-button-group class="smalflex pb-3">
            <!-- Each button in the Button Group is passed the id of the Question as the ':key' prop.  -->
            <!-- When the button is clicked, the current Question Index is updated to the index of the Button. And the answer data Property is cleared. -->
            <!-- A dynamic active or non-active class is attributed to the button if it is the active button in DOM. A dynamic Variant is also attributted to. -->
            <b-button
              v-for="(questionObject, index) in questionsArray"
              :key="questionObject.id"
              @click="(currentQuestionIndex = index), (answer = '')"
              :id="'_' + index"
              :class="[
                activeQuestionTrackid == questionObject.track_id
                  ? 'activeclass'
                  : 'nonactive'
              ]"
              :variant="getVariant(questionObject)"
              :disabled="disableButton(questionObject)"
              class="m-1 flexvfor"
            >
              {{ index + 1 }}
            </b-button>
          </b-button-group>
        </div>
      </b-card-footer>
      <p class="quep mt-3 ml-lg-5">
        <b-icon-question-square-fill></b-icon-question-square-fill> Question
        {{ currentQuestionIndex + 1 }} of {{ currentTabQuestions[0].length }}
      </p>

      <form
        v-if="Object.keys(currentQuestionObject()).length > 0"
        class="pl-5-lg"
      >
        <b-form-group label-for="queoption" class="pl-lg-5">
          <!-- 'currentQuestionObject' holds all the properties of the current question in an Object. -->
          <div
            v-if="
              currentQuestionObject()?.isAttachment == 'Yes' ||
              currentQuestionObject()?.isAttachment
            "
            class="mb-3"
          >
            <img
              :src="currentQuestionObject().image_link"
              class="qimage"
              Alt="Question Image"
            />
          </div>
          <div
            v-if="
              currentQuestionObject()?.isPassage == 'Yes' || currentQuestionObject()?.isPassage
            "
          >
            <h6>
              <b
                >Read the Passage Carefully and Answer the Question that
                Follows</b
              >
            </h6>
            <p v-html="currentQuestionObject().passage"></p>
          </div>

          <p v-html="currentQuestionObject().question"></p>
          <b-form-input
            v-if="currentQuestionObject().structure == 'OEQ'"
            id="oeqinput"
            v-model="oeqanswer"
            :disabled="disableOptions"
            @input="addanswer(oeqanswer)"
            placeholder="Type answer here"
            class="oeq-input mt-n3"
          ></b-form-input>
          <!-- {{ holdshortcut }} {{ answer }} -->
          <b-form-radio-group
            id="queoption"
            v-if="currentQuestionObject().structure == 'MCQ'"
            stacked
            v-model="answer"
            @change="addanswer($event)"
            class="form-rad"
          >
            <b-form-radio value="A" :disabled="disableOptions">
              <div class="dispf m-0">
                <!-- <p class="fl1 mr-2">a)</p> -->
                <p class="fl2" v-html="currentQuestionObject().a"></p>
              </div>
            </b-form-radio>
            <b-form-radio value="B" :disabled="disableOptions">
              <div class="dispf m-0">
                <!-- <p class="fl1 mr-2">b)</p> -->
                <p class="fl2" v-html="currentQuestionObject().b"></p>
              </div>
            </b-form-radio>
            <b-form-radio value="C" :disabled="disableOptions">
              <div class="dispf m-0">
                <!-- <p class="fl1 mr-2">c)</p> -->
                <p class="fl2" v-html="currentQuestionObject().c"></p>
              </div>
            </b-form-radio>
            <b-form-radio value="D" :disabled="disableOptions">
              <div class="dispf m-0">
                <!-- <p class="fl1 mr-2">d)</p> -->
                <p class="fl2" v-html="currentQuestionObject().d"></p>
              </div>
            </b-form-radio>
            <b-form-radio
              v-if="questionObj.e != ''"
              value="E"
              :disabled="disableOptions"
            >
              <div class="dispf m-0">
                <!-- <p class="fl1 mr-2">e)</p> -->
                <p class="fl2" v-html="currentQuestionObject().e"></p>
              </div>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </form>

      <div class="text-left pl-lg-5">
        <b-button-group>
          <!-- If any of this buttons are clicked, it either emits 'prevtab' or 'nexttab' events to the parents component. -->
          <!-- The 'prevtab' tells the parent that the user wants to go to the next tab and therefore the tabIndex is decreased by 1 except the user has gotten to the last tab-->
          <!-- The 'nexttab' tells the parent component that the user wants to go to the next tab and therefore the tabIndex ins increased by 1 except the user has gotten to the last tab -->
          <!-- The 'checkLimit' & 'checkLimit2' computed property checks if the User has navigated to the last question in this tab and then it shows the 'prev' or 'next' button in the DOM -->
          <!-- and also disables the > or < buttons in the DOM-->
          <!-- The 'checkEnd' and 'checkEnd2' checks if the user has reached the last tab in the testhall and then disables the 'prev' or 'next' buttons-->
          <!-- <b-button @click="$emit('prevtab')" v-if="checkLimit" ref='prev'  :disabled="checkEnd" class="pgbtne text-center mr-2">
                    <span class="mt-2">
                        <b-icon-chevron-left font-scale="0.9"></b-icon-chevron-left> Previous
                    </span>
                </b-button> -->
          <b-button
            @click="
              currentQuestionIndex = currentQuestionIndex - 1;
              currentQuestionOperations();
              currentQuestionOperations2();
            "
            ref="prev2"
            :disabled="checkLimit"
            class="pagbtn mr-1 prev"
          >
            <b-icon-chevron-left font-scale="0.9"></b-icon-chevron-left>
          </b-button>
          <b-button
            @click="
              currentQuestionIndex = currentQuestionIndex + 1;
              currentQuestionOperations();
              currentQuestionOperations2();
            "
            ref="next2"
            v-if="!checkLimit2"
            :disabled="checkLimit2"
            class="pagbtn ml-1 next"
          >
            <b-icon-chevron-right font-scale="0.9"></b-icon-chevron-right>
          </b-button>

          <!-- <b-button @click="$emit('nexttab')" v-if="checkLimit2 && !checkLimit3"  ref='next' :disabled="checkEnd2" class="pgbtne text-center ml-2">
                    <span class="mt-2">Next <b-icon-chevron-right font-scale="0.9"></b-icon-chevron-right></span>
                </b-button> -->

          <b-button
            @click="$emit('keysubmit')"
            v-if="checkLimit2"
            ref="submit"
            class="pgbtnsub text-center ml-2"
          >
            <span class="mt-2">Submit</span>
          </b-button>
        </b-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
//import miniTimer from "@/components/miniTimer"

export default {
  props: ["changeQuestion"],
  components: {
    //miniTimer
  },
  data() {
    return {
      held: "",
      questionObj: "",
      btnvariant: "outline-primary",
      currentQuestionIndex: 0,
      activeQuestionTrackid: "",
      answer: "",
      answeredObject: [],
      questionChanged: false,
      oeqanswer: "",
      oeqan: "",
      holdshortcut: false,
      holder: true,
      keypressed: false,
      updatedn: 0
    };
  },
  watch: {
    currentQuestionIndex(oldval, newval) {
      this.currentQuestionOperations();
      this.updatedn = 0;
      // console.log("chenged")
      if (oldval != newval) {
        this.questionChanged = true;
      }
    },
    changeQuestion(oldval, newval) {
      if (oldval != newval && newval == true) {
        this.currentQuestionIndex = this.currentQuestionIndex + 1;
      }
      this.updatedn = 0;
    }
  },
  created() {
    this.currentQuestionOperations();
    this.currentQuestionOperations2();
    // Forces the MathJax Library on the Testhall to allow for easy showing of Complex equations.
    // This is done because of Chromium Browsers that doesn't allow MathML show on their  browsers
    let mathjaxlink =
      this.environ == "development"
        ? "http://localhost/quicktest/plugins/Mathjax/MathJax.js?config=MML_HTMLorMML"
        : "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML";
    window.MathJax = {
      MathML: { extensions: ["mml3.js", "content-mathml.js"] }
    };
    let externalScript = document.createElement("script");
    externalScript.setAttribute("src", mathjaxlink);
    document.head.appendChild(externalScript);
    this.activeQuestionTrackid = this.questionObj.track_id;
  },
  mounted() {
    this.currentQuestionOperations();
    this.currentQuestionOperations2();
    // let self = this; // The 'windows' accepts 'this' as 'self' only
    // if(this.currentQuestionObject().structure == 'OEQ'){
    //         this.oeqanswer  = this.getanswer
    // }

    // This functionality allows the user to perform basic test functions without the use of a mouse by pressing only keyboard keys
    window.addEventListener("keyup", this.useShortcuts);
  },
  updated() {
    // console.log(`Updated -- ${this.updatedn}`)
    this.currentQuestionOperations();
    this.updatedn++;
  },

  methods: {
    ...mapActions("exam", ["addAnswer", "setCurrentQuestionId"]),

    currentQuestionOperations() {
      // console.log("called")
      this.setCurrentQuestionId(this.questionObj.track_id); // Gets the track ID of the Current Question displaying in the testhall and sets it in the store
      this.activeQuestionTrackid = this.questionObj.track_id; // Gets the track ID of the currrent Question displaying in the testhall and sets it in activeQuestionTrackid data property
      this.answeredObject = this.getanswered; // Gets the Object holding the answered object from the State and sets it in the component's 'answeredObject' data property
      this.answer = this.getanswer; // Gets the answer to the current question from the answeredObject in the Store
      if (this.updatedn <= 1) {
        if (this.currentQuestionObject().structure == "OEQ") {
          this.oeqanswer = this.getanswer;
        }
      }
    },
    currentQuestionOperations2() {
      // console.log("called2")
      this.setCurrentQuestionId(this.questionObj.track_id); // Gets the track ID of the Current Question displaying in the testhall and sets it in the store
      this.activeQuestionTrackid = this.questionObj.track_id; // Gets the track ID of the currrent Question displaying in the testhall and sets it in activeQuestionTrackid data property
      this.answeredObject = this.getanswered; // Gets the Object holding the answered object from the State and sets it in the component's 'answeredObject' data property
      this.answer = this.getanswer; // Gets the answer to the current question from the answeredObject in the Store

      if (this.currentQuestionObject().structure == "OEQ") {
        this.oeqanswer = this.getanswer;
      }
    },
    currentQuestionObject() {
      // This grabs the single object holding the current question displaying and sets it in questionObj data property
      // The SlicedTabQuestions is the array of all the questions of this Current Tab
      // The CurrentQuestionIndex is the index of the current question in the SlicedTabQuestions synonymous to the index in the button group
      this.questionObj = this.slicedTabQuestions[this.currentQuestionIndex];

      // returns the questionObj for use in the DOM by the calling the function directly
      return this.slicedTabQuestions[this.currentQuestionIndex];
    },

    addanswer(value) {
      this.oeqanswer = this.oeqanswer.toUpperCase();
      value = value.toUpperCase();
      this.addAnswer(value); // Calls the 'addAnswer' function in the store and passes the chosen answer to it
    },
    chkanswered() {
      this.answeredObject = this.answered.map(x => x.track_id); // Get only the track_id of all the questions that has been anwered into the answeredObject of the Data Property
    },
    getVariant(questionObj) {
      // Check if this particular question has been answered
      // If it has been answered then give it 'primary' variant else give it an 'outline-primary' variant
      if (this.answeredObject.find(o => o == questionObj.track_id)) {
        return "success";
      } else {
        return "outline-success";
      }
    },
    disableButton(questionObject) {
      if (
        this.start_config.mode == "Speed" ||
        this.start_config.mode == "Accuracy"
      ) {
        let isPresentIndex = this.mode_config.elapsed.findIndex(
          x => x == questionObject.track_id
        );

        if (this.start_config.mode == "Speed") {
          return isPresentIndex != -1 ? true : false;
        } else if (this.start_config.mode == "Accuracy") {
          return isPresentIndex != -1 &&
            0.2 * Number(this.testtime) < this.currenttime
            ? true
            : false;
        }
      } else {
        return false;
      }
    },
    addOEQAnswer() {
      this.oeqanswer = this.oeqanswer.toUpperCase();
    },
    holdShortcut() {
      // alert("HOLDING")
    },
    checkHolder() {
      return this.holdshortcut;
    },
    useShortcuts(ev) {
      this.keypressed = true;
      // let holding = this.checkHolder()
      // console.log(ev)
      // console.log(this.currentQuestionObject().structure)
      let oeqinput = {
        id: ""
      };

      if (this.currentQuestionObject().structure == "OEQ") {
        oeqinput = document.getElementById("oeqinput");
      }

      let activeelement = document.activeElement;

      // console.log(activeelement.id + "--" + oeqinput.id )

      // if(oeqinput.id == activeelement.id){
      //     console.log("They are equal")
      // }else{
      //     console.log("They didnt cross the mark")
      // }

      // console.log(oeqinput.id.length)

      if (
        oeqinput.id != activeelement.id &&
        (oeqinput.id.length > 0 || activeelement.id.length > 0)
      ) {
        // console.log("allowed to trigger")
        // let this = this
        // console.log(this.checkHolder())
        switch (ev.key) {
          case "N":
          case "n":
            // First check if the 'next' button has not been disabled

            if (!this.checkLimit2) {
              this.$refs.next2.click();
            }
            break;
          case "A":
          case "a":
            if (this.currentQuestionObject().structure == "MCQ") {
              this.answer = "A";
              this.addanswer("A");
            }
            break;
          case "B":
          case "b":
            if (this.currentQuestionObject().structure == "MCQ") {
              this.answer = "B";
              this.addanswer("B");
            }
            break;
          case "C":
          case "c":
            if (this.currentQuestionObject().structure == "MCQ") {
              this.answer = "C";
              this.addanswer("C");
            }
            break;
          case "D":
          case "d":
            if (this.currentQuestionObject().structure == "MCQ") {
              this.answer = "D";
              this.addanswer("D");
            }
            break;
          case "E":
          case "e":
            if (this.questionObj.e == "") {
              this.keypresser = false;
            } else {
              if (this.currentQuestionObject().structure == "MCQ") {
                this.answer = "E";
                this.addanswer("E");
              }
            }

            break;
          case "S":
          case "s":
            this.$emit("keysubmit");
            break;
          case "M":
          case "m":
            this.$emit("opencalc");
            break;
          case "P":
          case "p":
            // First check if the 'prev' button has not been disabled
            if (!this.checkLimit) {
              this.$refs.prev2.click();
            }
            break;
        }
      }

      if (ev.key == "Escape") {
        document.getElementById("oeqinput").blur();
      }
    }
  },
  computed: {
    ...mapGetters("exam", ["getanswered", "getanswer"]),

    ...mapState({
      loggedin: state => state.loginmaster.loggedIn,
      subjects: state => state.exam.subjects,
      currentTabQuestions: state => state.exam.currenttabquestions,
      slicedTabQuestions: state => state.exam.currenttabquestions[0],
      answered: state => state.exam.answered,
      environ: state => state.loginmaster.environ,
      start_config: state => state.exam.start_config,
      eachtime: state => state.exam.mode_config.eachtime,
      mode_config: state => state.exam.mode_config,
      currenttime: state => state.exam.currenttime,
      testtime: state => state.exam.testtime
    }),

    checkLimit() {
      // Check if the user have gotten to zero index, hence disable the back button
      // If we are not in the first tab, also show the 'prev' button to take the user to the previous tab
      return this.currentQuestionIndex < 1 ? true : false;
    },
    checkLimit2() {
      // Checks if the user has gotten to the last question of the present tab
      // If user has gotten to the last question, show the 'next' tab if its not the last tab of the testhall
      return this.currentQuestionIndex == this.slicedTabQuestions.length - 1
        ? true
        : false;
    },

    disableOptions() {
      if (
        this.start_config.mode == "Speed" ||
        this.start_config.mode == "Accuracy"
      ) {
        let isPresentIndex = this.mode_config.elapsed.findIndex(
          x => x == this.activeQuestionTrackid
        );

        if (this.start_config.mode == "Speed") {
          return isPresentIndex != -1 ? true : false;
        } else if (this.start_config.mode == "Accuracy") {
          return isPresentIndex != -1 &&
            0.2 * Number(this.testtime) < this.currenttime
            ? true
            : false;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.form-rad,
.form-rad span {
  cursor: pointer;
}

.anwsered {
  background-color: green;
  color: red;
}

.hobtn {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: thin;
  background-color: white;
  border: 0px;
}

.bactive {
  background-color: aquamarine;
}

.quep {
  font-weight: bold;
  font-size: 1rem;
}

.flexvfor {
  cursor: pointer;
}

.pagbtn {
  font-size: 20px;
  font-weight: bold;
  background-color: #243057;
  border-radius: 10px;
}

.pgbtne {
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 10px;
  background-color: #243057;
  border: 0px;
  padding: 10px;
  width: 120px;
}

.pgbtnsub {
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 10px;
  background-color: #00984a;
  border: 0px;
  padding: 10px;
  width: 120px;
}
.pgbtnsub:hover {
  background-color: #009849ad;
}

.activeclass {
  box-shadow: 0px 0px 5px 2px #00984a;
}

.dispf {
  display: flex;
  margin-top: -10px;
  cursor: pointer;
}
.oeq-input {
  border: 2px solid grey;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-radius: 0px;
}
.oeq-input:focus {
  border: 0px;
  box-shadow: 0px;
  outline: none;
}

@media screen and (max-width: 768px) {
  .qimage {
    width: 100%;
    height: 200px;
  }
}

@media screen and (min-width: 768px) {
  .qimage {
    width: 50%;
    height: 250px;
  }
}
</style>
